import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';


@Component({
    selector: 'app-simple-snackbar',
    template: `
    <div style="min-width: 250px;">
      <span>{{ data.message }}</span>
      
    </div>
  `,
  styleUrls: ['./simple-snackbar.component.scss'],
  standalone: false
})
export class SimpleSnackbarComponent {

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: { message: string; progress?: number }) {}

}
